import { useParams } from 'react-router-dom';

export function PlaceholderPage() {
  const { id } = useParams<{ id: string }>();
  const displayId = id ?? 'unknown';
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-white p-12 text-center">
      <p className="text-lg font-medium text-slate-600">Dashboard: {displayId}</p>
      <p className="mt-2 text-sm text-slate-500">
        Add your dashboard component and wire it in the router.
      </p>
    </div>
  );
}
